import type { WebConfig } from '../schemas';

export const webConfig: WebConfig = JSON.parse(process.env.SERVICE_CONFIG_WEB!);
